/**
 * @fileOverView
 * @description Invite component. mode 'vyb' (default) invites a peep to
 * subscribe to a vybit; mode 'org' invites a member to help manage the
 * account (docs/org-accounts-spec.md §4.4).
 * @copyright 2015-present Flatirontek LLC
 **/

var InviteTemplate = require('../../templates/components/invite.html');
var AmpersandView = require('ampersand-view');
var app = require('ampersand-app');
var dialog = require('../../lib/dialog');

var VALID_EMAIL = /^[^.\@\s][^\@\s]*@[a-z0-9][a-z0-9._-]*\.[a-z]{2,}$/;

var InviteView = AmpersandView.extend({

    props: {
      email: 'string',
      mode: ['string', true, 'vyb']
    },

    template : InviteTemplate,

    render: function(){
        this.renderWithTemplate(this);
        if(this.mode=="org"){
            this.updateOrgPlaceholder();
            if(app.orgMembers) this.listenTo(app.orgMembers, 'add remove reset sync', this.updateOrgPlaceholder);
            var devRow = this.query('[data-hook=invite-dev-access]');
            if(devRow) devRow.style.display = '';
        }
        return this;
    },

    updateOrgPlaceholder: function(){
        var input = this.query('#vinvite');
        if(!input) return;
        var remaining = app.utils.orgSeats().remaining;
        var text = remaining === Infinity
            ? '   email a manager invitation - unlimited seats'
            : '   email a manager invitation - ' + remaining + (remaining == 1 ? ' seat remaining' : ' seats remaining');
        input.setAttribute('placeholder', text);
    },

    events: {
        "click #sendinvite" : "sendInvite"
    },

    sendInvite: function(){
        //scope to this view; the profile page renders an invite bar and a
        //search bar side by side
        var input = this.query('#vinvite');
        if(!input) return;
        var email = input.value;

        if(!email.match(VALID_EMAIL)){
            input.setAttribute('placeholder','invalid email, try again');
            input.value="";
            return;
        }

        if(this.mode=="org") this.sendOrgInvite(input, email);
        else this.sendPeepInvite(input, email);
    },

    sendPeepInvite: function(input, email){
        var peep = new app.VybPeep();
        var data = {email:email, accessStatus:"invited"};
        data.vybKey = app.vyb.key;
        peep.save(data,{
            success: function(model,response){
                input.value = "";
                input.setAttribute('placeholder','email invitation to new peep');
                app.vybPeeps.fetch();
            },
            error: function(model,response,error){
                console.log('error inviting peep');
                console.log(error.message);
            }
        });
    },

    sendOrgInvite: function(input, email){
        var self = this;
        var devBox = this.query('#vinvite-dev-access');
        global.jQuery.ajax(Object.assign({
            url: app.config.restApiUrl + '/org/member',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({email: email, developer_access: !!(devBox && devBox.checked)}),
            success: function(){
                input.value = "";
                if(devBox) devBox.checked = false;
                if(app.orgMembers) app.orgMembers.fetch();
                self.updateOrgPlaceholder();
            },
            error: function(xhr){
                var msg = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : 'error sending invitation';
                dialog.alert(msg);
            }
        }, app.utils.setPersonalAuthTokenHeader()));
    }
});

module.exports = InviteView;
